import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";

export default class List extends Component {


	constructor(props, context) {
		super(props);

		this.columnModel = [
			{
				name: 'text',
				title: 'Text',
				field: 'text',
				renderer: (val) => {
					return <div style={{cursor:'pointer'}} onClick={() => this.select(val)}>{val}</div>
				}
			}
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
		};
		this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-praxepopup');
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'title', 'direction': 'asc'};
	}

	select(val) {
		this.props.onSelect(val);
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('praxe.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('praxe.change', this.changeListener);
	}


	render() {

		return (
			<Datagrid
				ref="datagrid"
				id="praxepopup"
				api="praxe.getList"
				buttons={<h5>Vyberte šablonu textu</h5>}
				saveState={false}
				filters={['fulltext']}
				filter={this.filter}
				limit={10}
				columnModel={this.columnModel}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Praxe/PickerList.js